import { APP_BASE_URL, MARKETING_BASE_URL } from "@/lib/constants/routes";
import { CTAButton } from "./cta-button";

export function Footer() {
    const footerSections = [
        {
            title: "Product",
            links: [
                { name: "Pricing", href: `${MARKETING_BASE_URL}/pricing` },

                {
                    title: "Login",
                    links: [
                        {
                            name: "Parent",
                            href: `${APP_BASE_URL}/login/parent`,
                        },
                        {
                            name: "Student",
                            href: `${APP_BASE_URL}/login/student`,
                        },
                        {
                            name: "School Teacher",
                            href: `${APP_BASE_URL}/login/teacher`,
                        },
                        {
                            name: "School Admin",
                            href: `${APP_BASE_URL}/login/admin`,
                        },
                        {
                            name: "School PO Processor",
                            href: `${APP_BASE_URL}/login/po-processor`,
                        },
                        {
                            name: "Affiliates",
                            href: `${APP_BASE_URL}/affiliate-auth`,
                        },
                    ],
                },
            ],
        },
        {
            title: "Core Curriculum",
            links: [
                { name: "Saxon Math", href: `${MARKETING_BASE_URL}/curriculum/saxon-math` },
                {
                    name: "Singapore Math-Dimensions",
                    href: `${MARKETING_BASE_URL}/curriculum/singapore-math-dimensions`,
                },
                {
                    name: "Saxon vs Singapore Comparison",
                    href: `${MARKETING_BASE_URL}/curriculum/comparison`,
                },
                {
                    title: "Supplementary",
                    links: [
                        { name: "Drill Team", href: `${MARKETING_BASE_URL}/drill-team` },
                        { name: "Learning Lab", href: `${MARKETING_BASE_URL}/learning-lab` },
                    ],
                },
            ],
        },
        {
            title: "Resources",
            links: [
                { name: "Placement Tests", href: `${MARKETING_BASE_URL}/placement-tests` },
                { name: "Textbooks", href: `${MARKETING_BASE_URL}/textbooks` },
                { name: "Blog", href: `${MARKETING_BASE_URL}/blog` },
                { name: "Shop", href: "https://store.nicolethemathlady.com/" },
                { name: "Testimonials", href: `${MARKETING_BASE_URL}/testimonials` },
            ],
        },
        {
            title: "Company",
            links: [
                { name: "About", href: `${MARKETING_BASE_URL}/about` },
                { name: "We're hiring", href: `${MARKETING_BASE_URL}/careers` },
                { name: "Become an Affiliate", href: `${MARKETING_BASE_URL}/affiliates` },
                {
                    title: "Support",
                    links: [
                        { name: "FAQs", href: `${MARKETING_BASE_URL}/faqs` },
                        { name: "Contact us", href: `${MARKETING_BASE_URL}/contact` },
                    ],
                },
            ],
        },
    ];

    return (
        <footer className="bg-black text-white relative">
            {/* Decorative color bar */}
            <div className="w-full h-2 flex border border-t border-black">
                <div className="bg-success-light flex-1 border-r border-black"></div>
                <div className="bg-info-medium flex-1 border-r border-black"></div>
                <div className="bg-accent-medium flex-1 border-r border-black"></div>
                <div className="bg-highlight-purple flex-1 border-r border-black"></div>
                <div className="bg-success-light flex-1 border-r border-black"></div>
                <div className="bg-highlight-purple flex-1"></div>
            </div>

            <div className="px-4 pt-12 pb-4 md:pt-20 md:pb-4">
                <div className="max-w-6xl mx-auto">
                    <div className="flex flex-col gap-10 md:gap-14">
                        {/* Header Section */}
                        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                            <div className="flex flex-col">
                                <h2 className="font-medium text-2xl md:text-3xl lg:text-4xl leading-tight text-neutral-light max-w-full md:w-70">
                                    Start your 7-day free trial.
                                </h2>
                            </div>

                            <div className="flex flex-row items-stretch sm:items-center gap-4">
                                <CTAButton
                                    href={`${MARKETING_BASE_URL}/pricing`}
                                    size="sm"
                                    className="bg-white text-black px-6 py-3 md:py-5 rounded-full text-sm leading-6 hover:bg-gray-100 transition-colors"
                                >
                                    Try for free
                                </CTAButton>

                                <CTAButton
                                    size="sm"
                                    href="https://app.nicolethemathlady.com/login"
                                    className="bg-transparent text-white px-6 py-3 md:py-5 rounded-full text-sm leading-6 border-white"
                                    variant="neutral"
                                >
                                    Login
                                </CTAButton>
                            </div>
                        </div>
                        {/* Footer Links Grid */}
                        <nav
                            className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8"
                            aria-label="Footer navigation"
                        >
                            {footerSections.map((section) => (
                                <div key={section.title} className="flex flex-col gap-0">
                                    <h3 className="font-medium text-sm leading-7 text-white opacity-60 mb-2">
                                        {section.title}
                                    </h3>
                                    <div className="flex flex-col gap-0">
                                        {section.links.map((link) => {
                                            if ("href" in link && typeof link.href === "string") {
                                                return (
                                                    <a
                                                        key={link.name}
                                                        href={link.href ? link.href : "#"}
                                                        className="text-sm leading-7 text-white hover:text-gray-300 transition-colors py-1"
                                                    >
                                                        {link.name}
                                                    </a>
                                                );
                                            }

                                            return (
                                                <div key={link.title} className="mt-2">
                                                    <p className="font-medium text-sm leading-7 text-white opacity-60 mb-2">
                                                        {link.title}
                                                    </p>
                                                    <div className="flex flex-col">
                                                        {link.links.map((subLink) => (
                                                            <a
                                                                key={subLink.name}
                                                                href={subLink.href}
                                                                className="text-sm leading-7 text-white hover:text-gray-300 transition-colors py-1"
                                                            >
                                                                {subLink.name}
                                                            </a>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}
                        </nav>

                        {/* Bottom Section */}
                        <div className="flex flex-col gap-3">
                            <div className="w-full h-px bg-white/10"></div>
                            <div className="flex flex-col md:flex-row items-center sm:justify-between  gap-4">
                                <div className="flex flex-row items-center flex-wrap gap-4 sm:gap-8 ">
                                    <a
                                        href={`${MARKETING_BASE_URL}/terms-of-service`}
                                        className="text-sm leading-7 text-white hover:text-gray-300 transition-colors"
                                    >
                                        Terms of Service
                                    </a>
                                    <a
                                        href={`${MARKETING_BASE_URL}/privacy-policy`}
                                        className="text-sm leading-7 text-white hover:text-gray-300 transition-colors"
                                    >
                                        Privacy Policy
                                    </a>
                                    <a
                                        href={`${MARKETING_BASE_URL}/refund-policy`}
                                        className="text-sm leading-7 text-white hover:text-gray-300 transition-colors"
                                    >
                                        Refund Policy
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="border-t mt-8 md:mt-14 border-[#2b2929]" />
                    <div className="copy-right text-xs py-2 max-w-6xl mx-auto">
                        Copyright © 2016–{new Date().getFullYear()} by Nicole the Math Lady. All content on this
                        website, including logos and graphics, is proprietary, copyrighted,
                        and owned or licensed by Nicole the Math Lady. Unauthorized use of
                        copyrighted content or trademarks is prohibited. All rights are
                        reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
}
